

require("jquery");
require("angularPlaceHolderShim");
var _index = require("js/lib/index");
require("xo-tracking/dist/index");
define(['angular', 'squid/index', './directive', 'pages/xo-landing/route', 'pages/xo-generic-error/route', 'pages/xo-generic-message/route', 'pages/xo-end/route', 'pages/xo-guest/route', 'pages/xo-signup/route', 'pages/xo-add-card/route', 'xo-guest-components/src/multistep-signup/route', 'pages/xo-pay-upon-invoice/route', 'xo-page-components/src/done/route', 'xo-page-components/src/route-to-complete/route', 'xo-guest-components/src/guest-authnode/route', 'xo-guest-components/src/continue-3ds-redirect/route', 'xo-form-components/src/inventory-soldout/route'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-checkout.route', ['squid', 'hermes.page.xo-landing.route', 'hermes.page.xo-checkout.directive', 'hermes.page.xo-generic-error.route', 'hermes.page.xo-generic-message.route', 'hermes.page.xo-end.route', 'hermes.page.xo-guest.route', 'hermes.page.xo-signup.route', 'hermes.page.xo-add-card.route', 'xo-multistep-signup.route', 'hermes.page.xo-pay-upon-invoice.route', 'xo-done', 'xo-route-to-complete', 'xo-guest-authnode']).factory('$BaseRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('CheckoutRoute', {
      defaultState: 'checkout.landing',
      middleware: _index.$Middleware,
      name: 'checkout',
      directive: 'xo-checkout',
      titleContent: 'base.payPal',
      children: [{
        name: '$LandingRoute',
        attributes: {
          'is-unbranded': 'isUnbranded'
        }
      }, {
        name: '$GuestRoute',
        attributes: {
          token: 'token',
          'is-unbranded': 'isUnbranded',
          'payment-method': 'paymentMethod',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$SignupRoute',
        attributes: {
          token: 'token',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$AddCardPageRoute',
        attributes: {
          token: 'token'
        }
      }, {
        name: '$xoSoldOutPageRoute'
      }, {
        name: '$GenericErrorRoute'
      }, {
        name: '$GenericMessageRoute'
      }, {
        name: '$EndRoute'
      }, {
        name: '$MultistepSignupRoute',
        attributes: {
          token: 'token',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$PayUponInvoiceRoute',
        attributes: {
          token: 'token',
          'is-unbranded': 'isUnbranded'
        }
      }, {
        name: '$DoneRoute'
      }, {
        name: '$RouteToCompleteRoute',
        attributes: {
          token: 'token'
        }
      }, {
        name: '$GuestAuthNodeRoute',
        attributes: {
          token: 'token'
        }
      }]
    });
  });
});
_index.$Middleware;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/route.js
// module id = ./pages/xo-checkout/route.js
// module chunks = 0